module.exports = __webpack_public_path__ + "img/layout_horizontal_s.a940e248.svg";